import { wrapRetry } from '@perpay-web/utils/importUtils';

export const importCardActivationContainer = () =>
    wrapRetry(
        () =>
            import(
                /* webpackChunkName: "CardActivation" */
                '@perpay-web/fintech/components/containers/CardActivationContainer'
            ),
    );
